import type { KeyboardEvent } from "react";

/**
 * Arrow keys, Home and End move between the tabs of a `role="tablist"` and select the one they
 * land on (WAI-ARIA tabs pattern, automatic activation). Pair with `tabIndex={selected ? 0 : -1}`
 * on each tab so Tab moves past the list in one step.
 */
export function onTablistKeyDown(event: KeyboardEvent<HTMLElement>): void {
  if (event.altKey || event.ctrlKey || event.metaKey) return;
  const tabs = [...event.currentTarget.querySelectorAll<HTMLElement>('[role="tab"]')];
  const current = tabs.indexOf(event.target as HTMLElement);
  if (current < 0 || tabs.length === 0) return;
  const last = tabs.length - 1;
  const next =
    event.key === "ArrowRight" || event.key === "ArrowDown"
      ? current === last
        ? 0
        : current + 1
      : event.key === "ArrowLeft" || event.key === "ArrowUp"
        ? current === 0
          ? last
          : current - 1
        : event.key === "Home"
          ? 0
          : event.key === "End"
            ? last
            : undefined;
  if (next === undefined) return;
  event.preventDefault();
  tabs[next]?.focus();
  tabs[next]?.click();
}
